import React from 'react';
import { twMerge } from 'tailwind-merge';
import { EmailGuardrailSuggestion } from '@scale/shared-types';
import { Alert } from 'design-system';
import { Typography, Spinner } from '@scale/scaleui';

const ContentSuggestions = ({
  suggestions,
  isLoadingEmailContentValidation,
}: {
  suggestions: EmailGuardrailSuggestion[];
  isLoadingEmailContentValidation?: boolean;
}) => {
  const suggestionsHeaderText =
    suggestions && suggestions.length > 1
      ? `Address ${suggestions.length} suggestions.`
      : suggestions && suggestions.length === 1
      ? 'Address 1 suggestion.'
      : 'No suggestions available.';

  return (
    <div
      className={twMerge(
        'rounded h-full overflow-y-auto w-full min-w-1/2 text-wrap whitespace-normal border border-solid border-neutral-200',
      )}
    >
      {isLoadingEmailContentValidation ? (
        <div className="flex h-full w-full justify-center items-center">
          <Spinner size="lg" />
        </div>
      ) : suggestions && suggestions.length > 0 ? (
        <div className="flex flex-col gap-4 p-4">
          <Alert severity="warning" className="py-0">
            {suggestionsHeaderText}
          </Alert>
          <div className="flex flex-col">
            <div className="flex justify-between border-b border-neutral-200 pb-2 gap-x-4">
              <Typography.Paragraph3 className="w-1/2 text-left mb-2 text-neutral-500">
                Content
              </Typography.Paragraph3>
              <Typography.Paragraph3 className="w-1/2 text-left mb-2 text-neutral-500">
                Suggestion
              </Typography.Paragraph3>
            </div>
            {suggestions.map((suggestion, index) => (
              <div
                key={index}
                className="flex justify-between border-b border-neutral-200 text-neutral-800 leading-normal gap-x-4"
              >
                <Typography.Paragraph2 className="my-2 w-1/2 text-left break-words">
                  {suggestion.flaggedContent}
                </Typography.Paragraph2>
                <Typography.Paragraph2 className="my-2 w-1/2 text-left break-words">
                  {suggestion.alternative}
                </Typography.Paragraph2>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-full">
          <p>{suggestionsHeaderText}</p>
        </div>
      )}
    </div>
  );
};

export default ContentSuggestions;
